module.exports = __webpack_public_path__ + "img/loja-icon.ff599666.svg";